module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "分片分配详情",
      "visible": _vm.isVisible,
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Executor"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.executorAllocationInfo.executorName))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "负荷"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.executorAllocationInfo.totalLoadLevel))])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分片分布"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [(Object.entries(_vm.executorAllocationInfo.allocationMap).length === 0) ? _c('div', [_vm._v("无")]) : _c('div', _vm._l((Object.entries(_vm.executorAllocationInfo.allocationMap)), function(item) {
    return _c('el-tag', {
      key: item[0],
      staticClass: "form-tags"
    }, [_vm._v(_vm._s(item[0]) + " : " + _vm._s(item[1]))])
  }))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.closeDialog()
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28b5f7f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/job_list/executor_allocation_dialog.vue
// module id = 1390
// module chunks = 1